import React from "react";
import { Card, Col, Row } from "reactstrap";

const Collaborators = () => {
  return (
    <section className="pt-3 pt-sm-8 pb-8 position-relative bg-warning">
      <div className="position-absolute w-100 z-index-1 top-0 mt-n3">
        <svg
          width="100%"
          viewBox="0 -2 1920 157"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>wave-down</title>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill="#f8f9fa" fillRule="nonzero">
              <g id="wave-down">
                <path
                  d="M0,60.8320331 C299.333333,115.127115 618.333333,111.165365 959,47.8320321 C1299.66667,-15.5013009 1620.66667,-15.2062179 1920,47.8320331 L1920,156.389409 L0,156.389409 L0,60.8320331 Z"
                  id="Path-Copy-2"
                  transform="translate(960.000000, 78.416017) rotate(180.000000) translate(-960.000000, -78.416017) "
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div className="container mt-lg-5 mt-2 mt-md-4">
        <div className="mx-auto text-center">
          <h2 className="text-white font-weight-bolder mb-3">Collaborators</h2>
          <Row>
            <Col sm={12} md={6} className="mb-lg-0 mb-4">
              <Card className="info p-4 z-index-2">
                <div className="description">
                  <h5>GFELTP-Ghana</h5>
                  <p>
                    The GFELTP is a two-year postgraduate course of service and
                    on-the-job learning in applied epidemiology and public
                    health laboratory practice for scientists, physicians,
                    veterinarians, and other health professionals. It leads to
                    the award of a Master of Philosophy degree in Applied
                    Epidemiology and Disease Control (M. Phil). <br />
                    <br />
                    The vision of the GFELTP is to improve the health of the
                    people in Ghana and beyond. Its mission is to contribute to
                    addressing Ghana’s public health needs and priorities
                    through training and service provision. Main achievements
                    during this reporting period are detailed at the website{" "}
                    <a href="http://www.afenet.net/">http://www.afenet.net/</a>.
                  </p>
                </div>
              </Card>
            </Col>
            <Col sm={12} md={6} className="mb-lg-0 mb-4">
              <Card className="info p-4 z-index-2">
                <div className="description">
                  <h5>The President's Malaria Initiative (PMI) – IMPACT Malaria</h5>
                  <p>
                    The President's Malaria Initiative (PMI) is a U.S. Government initiative to control and eliminate malaria. It was launched by U.S. president George W. Bush in 2005, and has been continued by the successive U.S. presidents. The initiative has helped save millions of lives and contributed to substantial gains in education, productivity, and economic development. <br />
                    <br />
                    PMI started as a five-year initiative with the goal of reducing malaria deaths by 50% in 15 African countries. Thanks to the bipartisan support of Congress and the generosity of the American people, PMI now works in 24 partner countries in sub-Saharan Africa and three programs in the Greater Mekong Subregion in Southeast Asia–representing about 90% of the global malaria burden.<br />
                    <a href="https://www.measuremalaria.org/">
                      Home - PMI - President's Malaria Initiative
                    </a>
                  </p>
                </div>
              </Card>
            </Col>
            <Col sm={12} md={6} className="mb-lg-0 mb-4">
              <Card className="info p-4 z-index-2">
                <div className="description">
                  <h5>Country Health Information and Data Use (CHISU)Program</h5>
                  <p>
                    CHISU supports Ghana’s Ministry of Health (MOH) and GHS to strengthen their COVID-19 and malaria efforts by improving data quality and use in the country. CHISU is working with GHS, in particular the Center for Health Information Management (CHIM), the Policy Planning Monitoring and Evaluation Division (PPMED), and the NMEP, to strengthen the systems for collecting malaria-related data, assess the readiness of malaria data systems to interoperate, and strengthen the quality, analysis, and use of malaria data. CHISU is building and strengthening the capacity of district staff in data validation and usage through training followed by district supportive supervision follow-up visits: <br />                    <a href="https://chisuprogram.org/">
                      https://chisuprogram.org/
                    </a>
                  </p>
                </div>
              </Card>
            </Col>
            <Col sm={12} md={6} className="mb-lg-0 mb-4">
              <Card className="info p-4 z-index-2">
                <div className="description">
                  <h5>National Malaria Elimination Programme, Ghana</h5>
                  <p>
                    The National Malaria Elimination Programme (Ghana Health
                    Service) is the main institution in Ghana that formulates
                    policies and strategies for controlling malaria and
                    translating these into interventions. It is also responsible
                    for coordinating, supervising, and monitoring the
                    implementation of these interventions. <br />
                    <br />
                    Its overall goal is to facilitate human development by
                    reducing malaria morbidity by 50 percent and mortality by 90
                    percent by 2025 using 2019 as a baseline. This goal will be
                    achieved through overall health sector development, improved
                    strategic investments in malaria control, and increased
                    coverage toward universal access to malaria treatment and
                    prevention interventions, including at the community level.
                  </p>
                </div>
              </Card>
            </Col>
            <Col sm={12} md={6} className="mb-lg-0 mb-4">
              <Card className="info p-4 z-index-2">
                <div className="description">
                  <h5>World Health Organization, Ghana</h5>
                  <p>
                    The World Health Organization (WHO) is a specialized agency
                    of the United Nations established in 1948 to further
                    international cooperation for improved public health
                    conditions. The WHO Constitution, which establishes the
                    agency's governing structure and principles, states its main
                    objective as "the attainment by all peoples of the highest
                    possible level of health". <br />
                    <br />
                    It is headquartered in Geneva, Switzerland, with six
                    semi-autonomous regional offices and 150 field offices
                    worldwide. WHO is headed by the Director-General, who is
                    appointed by the World Health Assembly on the nomination of
                    the Executive Board. The Regional Director for Africa
                    represents the Director-General in the region and heads the
                    Regional Office in Ghana. WHO Ghana office are technical and
                    funding partners to the SM&E workshop.{" "}
                    <a href="https://www.who.int">https://www.who.int</a>
                  </p>
                </div>
              </Card>
            </Col>
            <Col sm={12} md={6} className="mb-lg-0 mb-4">
              <Card className="info p-4 z-index-2">
                <div className="description">
                  <h5>PMI Measure Malaria</h5>
                  <p>
                    PMI Measure Malaria is funded by the United States Agency for International Development to strengthen the capacity of developing countries to gather, interpret, and use data to improve health. The project creates tools and approaches for rigorous evaluations, providing evidence to address health challenges.<br />
                    <br />
                    PMI Measure Malaria strengthens health information systems so countries can make better decisions and sustain good health outcomes over time. This regional SM&E workshop is co-organized by PMI Measure Malaria staff from ICF. Visit PMI Measure Malaria online at:<br />
                    <a href="https://www.measuremalaria.org/">https://www.measuremalaria.org/</a>
                  </p>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <div className="position-absolute w-100 bottom-0 mn-n1">
        <svg
          width="100%"
          viewBox="0 -1 1920 166"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>wave-up</title>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(0.000000, 5.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
            >
              <g id="wave-up" transform="translate(0.000000, -5.000000)">
                <path
                  d="M0,70 C298.666667,105.333333 618.666667,95 960,39 C1301.33333,-17 1621.33333,-11.3333333 1920,56 L1920,165 L0,165 L0,70 Z"
                  fill="#ffffff"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </section>
  );
};

export default Collaborators;
